import React from 'react';
import styled from 'styled-components';

const MakerBadge: React.FC = () => {
  return (
    <Container>
      <Badge>
        <span>M</span>
      </Badge>
    </Container>
  );
};

export default MakerBadge;

const Container = styled.div`
  background: black;
  padding: 3px;
  border-radius: 3px;
  float: right;
`;
const Badge = styled.div`
  color: white;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1px solid white;
  font-weight: bold;
  font-size: 8px;
  align-items: center;
  justify-content: center;
  display: flex;
`;
